import { useMemo } from 'react';
import { extractTankBits, toBinaryString } from '../TabPanelCondition.utils';
const EMPTY_GUARD_DATA = {
    guardOutNumber: 0,
    guardStatusNumber: 0,
    guardOut: '000000000',
    guardStatus: '000000000',
    guardOutTank: '000000',
    guardStatusTank: '000000',
};
export const useGuardData = (transportConditionItem, galileoskyDevice) => {
    return useMemo(() => {
        if (!galileoskyDevice || !(transportConditionItem === null || transportConditionItem === void 0 ? void 0 : transportConditionItem.data)) {
            return EMPTY_GUARD_DATA;
        }
        const guardOutNumber = transportConditionItem.data.guard_out;
        const guardStatusNumber = transportConditionItem.data.guard_status;
        return {
            guardOutNumber,
            guardStatusNumber,
            guardOut: toBinaryString(guardOutNumber),
            guardStatus: toBinaryString(guardStatusNumber),
            guardOutTank: extractTankBits(guardOutNumber),
            guardStatusTank: extractTankBits(guardStatusNumber),
        };
    }, [transportConditionItem, galileoskyDevice]);
};
